import emailSpellChecker from "@zootools/email-spell-checker";

// Returns a full corrected email (e.g. "jane@gmail.com") when the address
// looks like a domain/TLD typo (gmail.cm, yahoo.comm, hotmial.con, ...),
// or null when it looks fine or there is no confident suggestion.
//
// We only ever suggest, never auto-correct: the username half is left
// untouched and a legit-but-rare domain (ymail.com, gmx.com) is left alone.
export function getEmailSuggestion(email) {
  if (!email || typeof email !== "string" || !email.includes("@")) return null;
  try {
    const result = emailSpellChecker.run({ email: email.trim() });
    if (!result || !result.full) return null;
    if (result.full.toLowerCase() === email.trim().toLowerCase()) return null;
    return result.full;
  } catch (e) {
    return null;
  }
}
